export default __webpack_public_path__ + "static/media/dance.1f582169.gif";